(() => {
  if (window.__mmaGloveFinderEntryV18 === true) return;
  window.__mmaGloveFinderEntryV18 = true;

  const GA4_MEASUREMENT_ID = "G-PKHVJ3LX7Z";
  const META_PIXEL_ID = "578895468205709";
  const TRACKING_VERSION = "mma_glove_finder_entry_20260724_v18";
  const META_EVENT_NAMES = Object.freeze({
    mma_glove_finder_entry_view: "MMAFinderEntryView",
    mma_glove_finder_entry_click: "MMAFinderEntryClick",
  });
  const pendingViews = new Map();
  const deliveredViews = new Set();
  const observedLinks = new WeakSet();

  const compact = (input) => {
    const output = {};
    Object.keys(input || {}).forEach((key) => {
      const value = input[key];
      if (value !== undefined && value !== null && value !== "") {
        output[key] = value;
      }
    });
    return output;
  };

  const normalizeText = (value, limit = 100) =>
    String(value || "").replace(/\s+/g, " ").trim().slice(0, limit);

  const analyticsStatus = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (
        privacy &&
        typeof privacy.analyticsProcessingAllowed === "function"
      ) {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      return false;
    }
    return true;
  };

  const analyticsAllowed = () => analyticsStatus() === true;

  const marketingStatus = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === "function") {
        return privacy.marketingAllowed();
      }
    } catch (error) {
      return false;
    }
    return null;
  };

  const marketingAllowed = () => marketingStatus() === true;

  const getCookie = (name) => {
    const prefix = `${name}=`;
    const item = document.cookie
      .split("; ")
      .find((cookie) => cookie.indexOf(prefix) === 0);
    return item ? decodeURIComponent(item.slice(prefix.length)) : "";
  };

  const sessionValue = (key, factory) => {
    try {
      const stored = window.sessionStorage.getItem(key);
      if (stored) return stored;
      const value = factory();
      window.sessionStorage.setItem(key, value);
      return value;
    } catch (error) {
      return factory();
    }
  };

  const gaClientId = () => {
    const parts = getCookie("_ga").split(".");
    if (parts.length >= 4) return parts.slice(-2).join(".");
    return sessionValue(
      "mma_finder_entry_ga_cid",
      () =>
        `${Math.floor(Math.random() * 2147483647)}.${Math.floor(
          Date.now() / 1000
        )}`
    );
  };

  const gaSessionId = () => {
    const cookieName = `_ga_${GA4_MEASUREMENT_ID.replace("G-", "")}`;
    const value = getCookie(cookieName);
    const gs2 = value.match(/(?:^|\$)s(\d+)(?:\$|$)/);
    if (gs2) return gs2[1];
    const gs1 = value.match(/^GS\d+\.\d+\.(\d+)(?:\.|$)/);
    if (gs1) return gs1[1];
    return sessionValue("mma_finder_entry_ga_sid", () =>
      String(Math.floor(Date.now() / 1000))
    );
  };

  const sendGa4Direct = (name, payload) => {
    const query = new URLSearchParams({
      v: "2",
      tid: GA4_MEASUREMENT_ID,
      cid: gaClientId(),
      en: name,
      _p: String(Date.now()),
      dl: window.location.href,
      dt: document.title,
      sr: `${window.screen.width}x${window.screen.height}`,
      ul: (navigator.language || "en-us").toLowerCase(),
      sid: gaSessionId(),
      sct: "1",
      seg: "1",
    });

    Object.keys(payload).forEach((key) => {
      const value = payload[key];
      query.set(`${typeof value === "number" ? "epn" : "ep"}.${key}`, value);
    });

    const endpoint = `https://region1.analytics.google.com/g/collect?${query}`;
    let sent = false;
    try {
      sent =
        typeof navigator.sendBeacon === "function" &&
        navigator.sendBeacon(endpoint, "");
    } catch (error) {
      sent = false;
    }
    if (!sent && typeof window.fetch === "function") {
      window
        .fetch(endpoint, {
          method: "POST",
          mode: "no-cors",
          keepalive: true,
        })
        .catch(() => {});
    }
  };

  const sendGa4 = (name, payload) => {
    if (!analyticsAllowed()) return;
    try {
      if (typeof window.gtag === "function") {
        window.gtag(
          "event",
          name,
          Object.assign(
            {
              send_to: GA4_MEASUREMENT_ID,
              transport_type: "beacon",
            },
            payload
          )
        );
        return;
      }
    } catch (error) {
      // Continue through the consent-aware direct transport.
    }
    sendGa4Direct(name, payload);
  };

  const sendTripleWhale = (name, payload) => {
    if (!analyticsAllowed()) return false;
    try {
      if (typeof window.TriplePixel === "function") {
        window.TriplePixel("custom", name, payload);
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const ensureMetaPixel = () => {
    if (typeof window.fbq !== "function") {
      const fbq = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];
      window.fbq = fbq;

      const script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      const firstScript = document.getElementsByTagName("script")[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }

    if (window.__mmaMetaPixelInitialized !== META_PIXEL_ID) {
      window.fbq("init", META_PIXEL_ID);
      window.__mmaMetaPixelInitialized = META_PIXEL_ID;
    }
  };

  const sendMeta = (name, payload) => {
    const metaEvent = META_EVENT_NAMES[name];
    if (!metaEvent || !marketingAllowed()) return false;
    try {
      ensureMetaPixel();
      window.fbq("trackCustom", metaEvent, payload);
      return true;
    } catch (error) {
      return false;
    }
  };

  const publishShopify = (name, payload) => {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {
      // GA4 and Triple Whale remain the primary reporting destinations.
    }
  };

  const eventKey = (name, payload) =>
    [
      name,
      payload.source_path || window.location.pathname,
      payload.entry_surface || "",
      payload.entry_position || "",
    ].join("|");

  const isDebugMode = () => {
    const query = new URLSearchParams(window.location.search);
    return (
      query.get("mma_finder_entry_debug") === "1" ||
      query.get("_qa") === "mma-finder-entry-v18"
    );
  };

  const recordDebug = (root, name, payload) => {
    const detail = Object.assign(
      {
        event: name,
        analytics_allowed: analyticsStatus(),
        marketing_allowed: marketingStatus(),
        ga_transport: typeof window.gtag === "function" ? "gtag" : "direct",
        triple_whale_available: typeof window.TriplePixel === "function",
        meta_pixel_available: typeof window.fbq === "function",
      },
      payload
    );
    document.dispatchEvent(
      new CustomEvent("mma:glove-finder-entry", { detail })
    );
    if (isDebugMode() && window.console && console.info) {
      console.info("[MMA Finder Entry]", JSON.stringify(detail));
    }

    let history = window.__mmaGloveFinderEntryDebug || [];
    try {
      const stored = window.sessionStorage.getItem(
        "mma_glove_finder_entry_debug"
      );
      if (stored) history = JSON.parse(stored);
    } catch (error) {
      history = window.__mmaGloveFinderEntryDebug || [];
    }
    history.push(detail);
    history = history.slice(-30);
    window.__mmaGloveFinderEntryDebug = history;
    try {
      window.sessionStorage.setItem(
        "mma_glove_finder_entry_debug",
        JSON.stringify(history)
      );
    } catch (error) {
      // The element-level debug receipt remains available.
    }

    if (isDebugMode() && root) {
      root.setAttribute("data-mma-last-event", JSON.stringify(detail));
      root.setAttribute(
        "data-mma-event-sequence",
        JSON.stringify(history)
      );
    }
  };

  const deliver = (name, payload) => {
    const key = eventKey(name, payload);
    if (name.endsWith("_view")) {
      if (deliveredViews.has(key)) return;
      deliveredViews.add(key);
    }
    sendGa4(name, payload);
    if (!sendTripleWhale(name, payload)) {
      window.setTimeout(() => sendTripleWhale(name, payload), 1500);
    }
    sendMeta(name, payload);
    publishShopify(name, payload);
  };

  const publish = (name, payload, root, attempt = 0) => {
    const cleanPayload = compact(payload);
    if (attempt === 0) recordDebug(root, name, cleanPayload);

    const status = analyticsStatus();
    if (status === null && attempt < 12) {
      window.setTimeout(
        () => publish(name, cleanPayload, root, attempt + 1),
        250
      );
      return;
    }
    if (status !== true) {
      if (name.endsWith("_view")) {
        pendingViews.set(eventKey(name, cleanPayload), {
          name,
          payload: cleanPayload,
        });
      }
      return;
    }
    deliver(name, cleanPayload);
  };

  const flushPendingViews = () => {
    if (!analyticsAllowed()) return;
    pendingViews.forEach(({ name, payload }) => deliver(name, payload));
    pendingViews.clear();
  };

  const interactionMethod = (event) =>
    event && event.detail === 0 ? "keyboard" : "pointer";

  const inferEntry = (link) => {
    const root = link.closest("[data-mma-glove-finder-entry-root]");
    const footer = link.closest("[data-mma-footer-guides]");
    const bottomRecovery = link.closest(
      '[id*="image_with_text_aux"], .shopify-section[id*="image_with_text_aux"]'
    );
    const articleRoot = link.closest("article[data-mma-blog-attribution]");
    const destination = new URL(link.href, window.location.origin);
    const sourceTemplate =
      root?.dataset.sourceTemplate ||
      document.documentElement.className
        .split(/\s+/)
        .find((name) => name.indexOf("template-") === 0)
        ?.replace("template-", "") ||
      "";

    let entrySurface =
      link.dataset.entrySurface || root?.dataset.entrySurface || "";
    let entryPosition =
      link.dataset.entryPosition || root?.dataset.entryPosition || "";
    let entryVariant =
      link.dataset.entryVariant || root?.dataset.entryVariant || "";

    if (!entrySurface && footer) entrySurface = "footer";
    if (!entryPosition && footer) entryPosition = "fight_gear_guides";
    if (!entryVariant && footer) entryVariant = "utility_link";

    if (!entrySurface && bottomRecovery) entrySurface = "collection";
    if (!entryPosition && bottomRecovery) {
      entryPosition = "collection_bottom_recovery";
    }
    if (!entryVariant && bottomRecovery) entryVariant = "native_recovery";

    if (!entrySurface && articleRoot) entrySurface = "blog";
    if (!entryPosition && articleRoot) entryPosition = "article_end";
    if (!entryVariant && articleRoot) entryVariant = "contextual";

    return compact({
      entry_surface: normalizeText(entrySurface || "storefront"),
      entry_position: normalizeText(entryPosition || "contextual"),
      entry_variant: normalizeText(entryVariant || "link"),
      source_path: window.location.pathname,
      destination_path: destination.pathname,
      source_template: normalizeText(sourceTemplate),
      collection_handle: normalizeText(
        root?.dataset.collectionHandle || ""
      ),
      product_handle: normalizeText(root?.dataset.productHandle || ""),
      blog_article: normalizeText(
        root?.dataset.blogArticle ||
          articleRoot?.dataset.mmaBlogArticle ||
          ""
      ),
      blog_category: normalizeText(
        root?.dataset.blogCategory ||
          articleRoot?.dataset.mmaBlogCategory ||
          ""
      ),
      entry_link_text: normalizeText(link.textContent),
      tracking_version: TRACKING_VERSION,
    });
  };

  const trackVisible = (link, payload) => {
    if (observedLinks.has(link)) return;
    observedLinks.add(link);

    const record = () =>
      publish("mma_glove_finder_entry_view", payload, link);
    if (!("IntersectionObserver" in window)) {
      record();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        record();
      },
      { threshold: 0.35 }
    );
    observer.observe(link);
  };

  const initializeEntry = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (link.dataset.mmaFinderEntryBound === "true") return;
    link.dataset.mmaFinderEntryBound = "true";

    const payload = inferEntry(link);
    trackVisible(link, payload);
    link.addEventListener("click", (event) => {
      publish(
        "mma_glove_finder_entry_click",
        Object.assign({}, inferEntry(link), {
          interaction_method: interactionMethod(event),
        }),
        link
      );
    });
  };

  const initializeAll = () => {
    document
      .querySelectorAll(
        'a[data-mma-glove-finder-entry], a[href="/pages/glove-finder"], a[href$="/pages/glove-finder"]'
      )
      .forEach(initializeEntry);
  };

  const alignDirectReviewLink = () => {
    const hash = window.location.hash || "";
    if (!hash.startsWith("#mma-glove-finder-entry-")) return;
    const target = document.getElementById(hash.slice(1));
    if (!target) return;
    target.setAttribute("data-mma-direct-review-target", "true");
    const alignTarget = () => {
      const targetTop =
        target.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: "auto",
      });
    };
    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(alignTarget);
    } else {
      alignTarget();
    }
  };

  const scheduleDirectReviewLink = () => {
    alignDirectReviewLink();
    [250, 1200, 2500].forEach((delay) => {
      window.setTimeout(alignDirectReviewLink, delay);
    });
  };

  document.addEventListener(
    "visitorConsentCollected",
    flushPendingViews
  );
  document.addEventListener("shopify:section:load", initializeAll);

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        initializeAll();
        scheduleDirectReviewLink();
      },
      { once: true }
    );
  } else {
    initializeAll();
    scheduleDirectReviewLink();
  }

  if (document.readyState !== "complete") {
    window.addEventListener("load", scheduleDirectReviewLink, {
      once: true,
    });
  }
})();
